import { useMemo } from 'react';

import Box from '@mui/material/Box';
import { Stack } from '@mui/material';
import { useParams } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';

import { AppchargeIcon } from '../../assets/icons';
import { loadStripe } from '../../utils/stripe-loader';
import { HandleNextAction } from './components/HandleNextAction';
import { useTranslation } from 'react-i18next';

export function HandlePayment() {
  const { pk } = useParams();
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });
  const stripePromise = useMemo(() => (pk ? loadStripe(pk) : null), [pk]);

  return (
    <Stack
      height={'100dvh'}
      width={'100vw'}
      bgcolor="white"
      position={'relative'}
      zIndex={99999}
      overflow={'hidden'}
      textAlign={'center'}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      <Box position={'relative'}>
        <Elements stripe={stripePromise}>
          <HandleNextAction />
        </Elements>
      </Box>
      <Stack flexDirection={'row'} alignItems={'center'} position={'absolute'} bottom={24}>
        <Box pr={1} fontSize={10}>
          {t('poweredBy')}
        </Box>
        <AppchargeIcon />
      </Stack>
    </Stack>
  );
}
